import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OperationsService {
    readonly BASE: any = PETICIONES.operations;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los operations
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un operations por su id
   */
  public findById(id: number): Observable<any> {
    let idoperations: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idoperations).pipe(delay(DELAY));
  }

}